$("#btnLimpar").on("click", function(ev) {
    ev.preventDefault();
    $.get('/limpabase', function(resp) {
        location.href = '';
    });
});
